import axios from 'axios'

export const config = {
	env: process.env.REACT_APP_ENV,
	baseUrl: process.env.REACT_APP_API_URL || '',
}

if(config.env === 'develop') console.table({config})

axios.defaults.baseURL = config.baseUrl